import ModalWrappedContent from '@/components/basicComponents/modal/modalWrappedContent';
import Input from '@/components/basicComponents/input';
import { useMutation } from '@apollo/client';
import { useState } from 'react';
import { UPDATE_DUE_DILIGENCE_FUNNEL_MUTATION } from '../queries';
import { saveOnEnter } from '../utils';

interface EditFunnelProps {
  onClose: () => void;
  isOpen: boolean;
  funnelName: string | null;
  funnelId: string | null;
}

const EditFunnel = ({ onClose, isOpen, funnelName, funnelId }: EditFunnelProps) => {
  if (!funnelName || !funnelId) return <></>;

  const [value, setValue] = useState(funnelName);

  const [updateFunnel] = useMutation(UPDATE_DUE_DILIGENCE_FUNNEL_MUTATION);

  const saveValue = () => {
    updateFunnel({
      variables: {
        data: {
          name: value,
          id: funnelId
        }
      },
      onCompleted: () => {
        onClose();
      }
    });
  };

  return (
    <ModalWrappedContent
      isOpen={isOpen}
      onClose={onClose}
      title="Edit Funnel"
      confirmButton={{ name: 'Save', onClick: saveValue, disabled: !value }}
      showRequiredFields
    >
      <Input
        value={value}
        onChange={(event) => setValue(event.target.value)}
        label="Name"
        type="text"
        placeholder="Give this Funnel a unique name"
        size="lg"
        onKeyUp={(event) => saveOnEnter(event, saveValue, !value)}
        isRequiredField
        autoFocus
      />
    </ModalWrappedContent>
  );
};

export default EditFunnel;
